<template>
  <div class="async-btn">
    <button type="button" class="reload-btn" v-if="!status" @click="emitData()" :aria-label="$t('op.refreshList')" :title="$t('op.refreshList')">
      <i class="fas fa-sync rotate" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'awaitReloadComponent',
  props: {
    status: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emitData() {
      this.$emit('await');
    }
  }
};
</script>

<style scoped>
.reload-btn {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
}
</style>
